import React from 'react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import KanbanCard from './KanbanCard';
import { getOpportunityValue, money } from './kanbanUtils';

const KanbanColumn = ({ id, title, tickets, color, index, updateTicket, isAdmin, busy }) => (
  <Draggable draggableId={`column:${id}`} index={index} isDragDisabled={!isAdmin || busy}>
    {(provided, snapshot) => <section className={`zk-column${snapshot.isDragging ? ' zk-column-dragging' : ''}`} ref={provided.innerRef} {...provided.draggableProps} style={{ ...provided.draggableProps.style, '--lane-color': color }} aria-label={title}>
      <header className="zk-column-header">
        <div className="zk-column-title"><span className="zk-lane-dot" /><h2>{title}</h2><span className="zk-count">{tickets.length}</span>
          {isAdmin && <span className="zk-drag-handle" {...provided.dragHandleProps} aria-label={`Reordenar etapa ${title}`}><DragIndicatorIcon fontSize="small" /></span>}
        </div>
        <p>Total <strong>{money(tickets.reduce((sum, ticket) => sum + getOpportunityValue(ticket), 0))}</strong></p>
      </header>
      <Droppable droppableId={id} type="CARD" isDropDisabled={busy}>
        {(drop, state) => <div className={`zk-card-list${state.isDraggingOver ? ' zk-drop-active' : ''}`} ref={drop.innerRef} {...drop.droppableProps}>
          {tickets.map((ticket, cardIndex) => <KanbanCard key={ticket.id} ticket={ticket} laneId={id} index={cardIndex} updateTicket={updateTicket} busy={busy} />)}
          {drop.placeholder}
          {!tickets.length && <div className="zk-empty-lane">Nenhuma oportunidade nesta etapa.<span>Arraste um cartão para cá.</span></div>}
        </div>}
      </Droppable>
    </section>}
  </Draggable>
);

export default KanbanColumn;
